import { toast } from "sonner";
import { AppError, classifyAxiosError } from "./errors";
import { getErrorMessage } from "./errorMessages";

export const toastError = (
  err: unknown,
  onRetry?: () => void
): AppError => {
  const appError =
    typeof err === "object" && err !== null && "kind" in (err as any)
      ? (err as AppError)
      : classifyAxiosError(err);
  const { title, description, retry } = getErrorMessage(appError);
  toast.error(title, {
    description,
    action:
      retry && onRetry
        ? { label: "Erneut versuchen", onClick: () => onRetry() }
        : undefined,
  });
  return appError;
};

export const toastSuccess = (message: string, description?: string) => {
  toast.success(message, description ? { description } : undefined);
};

export const toastInfo = (message: string, description?: string) => {
  toast(message, description ? { description } : undefined);
};

export { toast };
